module.exports = __webpack_public_path__ + "img/grid-picture-1x2.7523d762.jpg";